import {Extendable} from '@rocket-ui/tools';
import React, {ElementType, FC, PropsWithChildren} from 'react';
import {ContentLoader} from '../ContentLoader';
import {RequestLoader} from './RequestLoader';
import {SkeletonLoader} from './SkeletonLoader';

interface Props {
	isLoading: boolean;
}

export type LoaderProps<TTag extends ElementType> = Extendable<PropsWithChildren<Props>, TTag, 'loader'>;

export function Loader<TTag extends ElementType = typeof SkeletonLoader>({
	isLoading,
	loader,
	children,
	...props
}: LoaderProps<TTag>) {
	const LoaderComponent = loader || SkeletonLoader;

	return <>{isLoading ? <LoaderComponent {...props} /> : children}</>;
}

const DefaultLoader: FC = (props) => (
	<svg viewBox="0 0 24 24" className={'w-6 h-6 animate-spin'} {...props}>
		<circle fill="transparent" strokeWidth="2" cx="12" cy="12" r="10" stroke="url(#gradient)" />
		<linearGradient id="gradient">
			<stop offset="50%" stopOpacity="1" />
			<stop offset="65%" stopOpacity=".5" />
			<stop offset="100%" stopOpacity="0" />
		</linearGradient>
	</svg>
);

Loader.Skeleton = SkeletonLoader;
Loader.Content = ContentLoader;
Loader.Circles = RequestLoader;
Loader.Default = DefaultLoader;
